import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="searchOverall";

export function searchOverallList(searchText){
  return axios({
    url: `/ws/${moduleName}/searchOverallList`,
    method: 'get',
    params:searchText,
  })
}


export function selectAgencyAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectAgencyAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function selectLeaseAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectLeaseAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectMansionAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectMansionAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectNewsAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectNewsAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectCustomerAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectCustomerAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectDealAndPursuitsAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectDealAndPursuitsAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function searchOverallInsert(){
  return axios({
    url: `/ws/${moduleName}/searchOverallInsert`,
    method: 'get',
  })
}

export function searchOverallDelete(){
  return axios({
    url: `/ws/${moduleName}/searchOverallDelete`,
    method: 'get',
  })
}


export default {
  searchOverallList,
  searchOverallInsert,
  searchOverallDelete,
  selectAgencyAll,
  selectLeaseAll,
  selectMansionAll,
  selectNewsAll,
  selectCustomerAll,
  selectDealAndPursuitsAll,
}